import { DateTime } from "luxon";

export class Notification {
    constructor(
        public readonly id: number,
        public readonly type: string,
        public readonly title: string,
        public readonly message: string,
        public readonly url: string,
        public readonly createdAt: DateTime,
        public readonly readAt: DateTime | null,
    ) {}

    get isUnread(): boolean {
        return this.readAt === null;
    }
}
